import { Component, OnInit } from '@angular/core';
declare var jquery: any;
declare var $: any;
import 'datatables.net';
import { GridOptions } from "ag-grid/main";
import { Router } from '@angular/router';
import { Globals } from '../../globals';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { ToastrService } from 'ngx-toastr';
import { CoachService } from 'app/services/coach/CoachService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';

@Component({
  selector: 'app-archived-assessments',
  templateUrl: './archived-assessments.component.html',
    styleUrls: ['./archived-assessments.component.scss'],
    providers: [DownloadAssessmentManager]
})
export class ArchivedAssessmentsComponent implements OnInit {

    //data: string[] = [];
    regularAsessmentsData: string[] = [];
    asessments360Data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    //gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    rowSelection;

    height: number;
    count: number;

    loading: boolean = true;

    //enableResults: boolean = false;
    canAddRaters: boolean = false;
    restoring: boolean = false;
    regularGridApi: any;
    gridApi360: any;
    assessmentType: number = 4.1;
    tags = [];
    tags360 = [];
    assessmentEliTags = [];
    assessment360Tags = [];
    placeholder: string = "Enter tag";


    coachTags: any[] = [];
    coachTagsHeaders: any[];
    coachTagsGridApi;
    selectedCoachTags: any[] = [];
    currentAssessmentType: number;
    enabling: boolean = false;

    constructor(
        private _CoachService: CoachService,
        private router: Router,
        public _Globals: Globals,
        private _DownloadAssessmentManager: DownloadAssessmentManager,
        private _toastr: ToastrService,
        private _CryptoJs: CryptoJs
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        //$('#cHideFilter').addClass('notShow');

        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        //method  call
        //this.getCoachCompletedAssessments();

        if (this._Globals.completedUserId == undefined) {
            this.getCoachArchivedAssessments(1);
            this.getCoachArchivedAssessments(2);
        } else {
            this.loading = false;
        }
    }

    mouseEnter() {
        $('h1').css("padding-bottom", "0px");
    }

    onFocusInput() {
        console.log('onFocusInput');
        setTimeout(() => {
            $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
        }, 100);
    }

    getCoachArchivedAssessments(assessmentType: number) {
        this._CoachService.getCoachArchivedAssessments(assessmentType).subscribe((data: any) => {
            console.log('response_getCoachArchivedAssessments', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this._Globals.archivedRegularData = _data;
                } else {
                    this._Globals.archived360Data = _data;
                }
                this.loading = false;
                this._Globals.canRestoreAssessments = false;
            }

        });
    }

    getCoachArchivedAssessmentsByTypeByTag(assessmentType: number, tags: string[]) {
        this._CoachService.getCoachArchivedAssessmentsByTypeByTag(assessmentType, tags).subscribe((data: any) => {
            console.log('response_GetCoachArchivedAssessmentsByTypeByTag', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                if (_data.length > 0) {
                    if (assessmentType === 1) {
                        this._Globals.archivedRegularData = _data;
                    } else {
                        this._Globals.archived360Data = _data;
                    }
                } else {
                    if (tags.length === 0) {
                        this.getCoachArchivedAssessments(assessmentType);
                    } else {
                        if (assessmentType === 1) {
                            this._Globals.archivedRegularData = [];
                        } else {
                            this._Globals.archived360Data = [];
                        }
                    }
                }
            }

        });
    }

    onItemAdded(assessmentType, e) {
        console.log("onItemAdded", e);

        if (assessmentType === 1) {
            this.assessmentEliTags.push(e.value);
            console.log(this.assessmentEliTags);
            this.getCoachArchivedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        } else {
            this.assessment360Tags.push(e.value);
            console.log(this.assessment360Tags);
            this.getCoachArchivedAssessmentsByTypeByTag(2, this.assessment360Tags);
        }
    }

    onItemRemoved(assessmentType, e) {
        console.log("onItemRemoved", e);

        if (assessmentType === 1) {
            var index = this.assessmentEliTags.indexOf(e.value);
            if (index !== -1) this.assessmentEliTags.splice(index, 1);
            console.log(this.assessmentEliTags);
            this.getCoachArchivedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        } else {
            var index = this.assessment360Tags.indexOf(e.value);
            if (index !== -1) this.assessment360Tags.splice(index, 1);
            console.log(this.assessment360Tags);
            this.getCoachArchivedAssessmentsByTypeByTag(2, this.assessment360Tags);
        }


    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);
        setTimeout(() => {
            if (this.assessmentType === 4.1) {
                if (this.regularGridApi != undefined) {
                    this.sizeToFit(this.regularGridApi);
                }
            } else {
                if (this.gridApi360 != undefined) {
                    this.sizeToFit(this.gridApi360);
                }
            }
        }, 500);
    }

    showArchivedTabs() {
        $('.archivedTabs div').removeClass('active in');
        $('.archivedTabs li').removeClass('active');
        $('.archivedTabs li').eq(0).addClass('active');
        $('#archivedTab1').addClass('active');
        $('#archivedTab1').addClass('in');
    }


    tabSelected(index: number) {
        console.log(index);
        this.assessmentType = index;
        this.deselectAllCheckBox(this.regularGridApi);
        this.deselectAllCheckBox(this.gridApi360);

        if (index === 4.1) {
            this.sizeToFit(this.regularGridApi);
        } else {
            this.sizeToFit(this.gridApi360);
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    deselectAllCheckBox(gridApi) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        //$('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(grid: number, params) {
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
        if (grid === 1) {
            this.regularGridApi = params.api;
            this._Globals.archivedAssessmentGridApi = params.api;
        } else {
            this.gridApi360 = params.api;
        }
        //this.sizeToFit(this.gridApi);
    }

    createHeaders() {
        let columnDefs = new Array();


        let coachHeader = {
            headerName: 'Client',
            field: 'ClientFullName',
            minWidth: 150,
            width: 150,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(coachHeader);


        let nicheHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';

            }
        };
        columnDefs.push(nicheHeader);

        let completedHeader = {
            headerName: 'Completed on',
            field: 'CompletedOnDateTime',
            minWidth: 175,
            width: 175,
            sort: "desc",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log('data', data);
            this.descriptionAction(data['Id']);
        }
    }

    downloadAssessment(clientId: number, assignmentId: number, userType: number) {
        this._DownloadAssessmentManager.downloadReport(clientId, assignmentId, userType, this);
    }


    descriptionAction(assignmentId: number) {
        this.router.navigate(['/app/co_a_report', assignmentId, 'manage_assessments_completed', 1]);
    }

    shareAction() {
        console.log('shareAction');
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        let rowCount = event.api.getSelectedNodes().length;

        let rowCountData;
        if (this.assessmentType === 4.1) {
            rowCountData = this.getSelectedRows(this.regularGridApi);
        } else {
            rowCountData = this.getSelectedRows(this.gridApi360);
        }
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount >= 1) {
            this._Globals.canRestoreAssessments = true;
        } else {
            this._Globals.canRestoreAssessments = false;
        }

        if (rowCount == 1) {
            let rows;
            if (this.assessmentType === 4.1) {
                rows = this.getSelectedRows(this.regularGridApi);
            } else {
                rows = this.getSelectedRows(this.gridApi360);
            }
            let is360 = true;
            rows.forEach((assessment) => {
                console.log(assessment);
                if (!assessment.Is360) {
                    is360 = false;
                    return;
                }
            });
            if (is360) {
                this.canAddRaters = true;
            } else {
                this.canAddRaters = false;
            }
        } else {
            this.canAddRaters = false;
        }
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    focusTagsInput(id) {
        $('#' + id).focus();
    }

    /*Get Coach Tags*/
    openTagsModal(type: number) {
        this.currentAssessmentType = type;
        $("#archivedTagsModal").modal({ backdrop: "static" });
        $('#archivedTagsModal').modal('show');
        this.coachTagsHeaders = this.createCoachTagsHeaders();
        this.getCoachTags();
        this.sizeToFit(this.coachTagsGridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onCoachTagsGridReady(params) {
        this.coachTagsGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createCoachTagsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Tag',
            field: 'Text',
            minWidth: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);


        return columnDefs;
    }

    onCoachTagsRowClicked(e) {
        console.log(e);
    }

    onCoachTagsSelectionChanged(event) {
        console.log("onCoachTagsSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        this.selectedCoachTags = this.getSelectedRows(this.coachTagsGridApi);
        console.log("selectedCoachTags", this.selectedCoachTags);
    }


    getCoachTags() {
        this._CoachService.getCoachTags().subscribe((data: any) => {
            console.log('getCoachTags data', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachTags', _data);
                this.coachTags = _data;
            }
        });
    }

    removeTag(index, text) {
        console.log(index);

        this.selectedCoachTags.splice(index, 1);
        console.log(this.selectedCoachTags);

        this.coachTagsGridApi.forEachNode((node) => {
            console.log(node);
            if (text === node.data.Text) {
                node.setSelected(false);
            }
        });
    }

    addNewCoachTags() {

        this.selectedCoachTags.forEach((item) => {

            if (this.currentAssessmentType === 1) {
                if (!this.tags.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.tags.push(tag);
                    this.onItemAdded(1, tag);
                }
            } else {
                if (!this.tags360.find(x => x.value === item.Text)) {
                    let tag = { display: item.Text, value: item.Text };
                    this.tags360.push(tag);
                    this.onItemAdded(2, tag);
                }
            }

        });
        this.closeTagsModal();
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    closeTagsModal() {
        $('#archivedTagsModal').modal('hide');
        this.selectedCoachTags = [];
    }

    /*Archive Assessments*/
    openRestoreAssessmentsConfirmationModal() {
        if (this._Globals.canRestoreAssessments) {
            $("#restoreConfirmationModal").modal({ backdrop: "static" });
            $('#restoreConfirmationModal').modal('show');
        }
    }

    closeRestoreAssessmentsConfirmationModal() {
        if (this._Globals.canRestoreAssessments) {
            $('#restoreConfirmationModal').modal('hide');
            this._Globals.canRestoreAssessments = false;
            this._Globals.completedCanEnableResults = false;
        }
    }

    restoreAssessments() {
        if (this._Globals.canRestoreAssessments) {
            var selected;
            if (this.assessmentType === 4.1) {
                selected = this.getSelectedRows(this.regularGridApi);
            } else {
                selected = this.getSelectedRows(this.gridApi360);
            }

            this.restoring = true;
            console.log(selected);
            let assignmentIds = [];

            selected.forEach((item) => {
                console.log(item.Id);
                assignmentIds.push(item.Id)
            });
            console.log(assignmentIds);

            let data = {
                "AssignmentIds": assignmentIds,
                "Archived": 0
            };

            this._CoachService.postArchiveAssessments(this._CryptoJs.encrypt(JSON.stringify(data), 'Os6v70$B&E!H@MlKfTj9nZ34tPw!z%8*')).subscribe((data: any) => {
                if (this._Globals.validationToken(data.result.Result)) {
                    console.log('postArchiveAssessments_response', data.result.Result);

                    switch (data.result.Result) {
                        case -1:
                            this._toastr.error('We are sorry. Some of the selected assessments could not be restored', 'ELI');
                            break;

                        case 0:
                            this._toastr.error('We are sorry. An unexpected error happened when trying to restore the assessments', 'ELI');
                            break;

                        case 1:
                            this._toastr.success('Assessment restored successfully');
                            break;
                    }
                    this.restoring = false;
                    console.log(this.assessmentType);
                    if (this.assessmentType === 4 || this.assessmentType === 4.1) {
                        this.getCoachArchivedAssessments(1);
                    } else {
                        this.getCoachArchivedAssessments(2);
                    }
                    this.closeRestoreAssessmentsConfirmationModal();
                }
            });

        }
    }

    public getDisplayTagsCount(): number {
        const tags = $('[ng-reflect-input-id=archivedTagsInput] > .ng2-tag-input > .ng2-tags-container > tag');

        return tags.length;
    }

    public getDisplay360TagsCount(): number {
        const tags = $('[ng-reflect-input-id=archivedTagsInput360] > .ng2-tag-input > .ng2-tags-container > tag');

        return tags.length;
    }

    public reloadApplyingTagsFilter(): void {
        const tags = $('[ng-reflect-input-id=archivedTagsInput] > .ng2-tag-input > .ng2-tags-container > tag')
        for(let count: number = 0; count< tags.length; count++){
            const tagText = tags[count].children[0].children[0].innerText.trim();
            this.tags.push(tagText);
            this.assessmentEliTags.push(tagText);
        }

        if (tags.length > 0) {
            this.getCoachArchivedAssessmentsByTypeByTag(1, this.assessmentEliTags);
        }
    }

    public reloadApplying360TagsFilter(): void {
        const tags360 = $('[ng-reflect-input-id=archivedTagsInput360] > .ng2-tag-input > .ng2-tags-container > tag')
        for(let count: number = 0; count< tags360.length; count++){
            const tagText = tags360[count].children[0].children[0].innerText.trim();
            this.tags360.push(tagText);
            this.assessment360Tags.push(tagText);
        }

        if (tags360.length > 0) {
            this.getCoachArchivedAssessmentsByTypeByTag(2, this.assessment360Tags);
        }
    }

}

